// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../../common/http.res.js");
var Filter$ReactHooksTemplate = require("./filter.res.js");
var FilterPills$ReactHooksTemplate = require("./filterPills.res.js");
var DateFilterForm$ReactHooksTemplate = require("./DateFilterForm.res.js");
var FilterPillsElement$ReactHooksTemplate = require("./FilterPillsElement.res.js");
var InsightsFilterForm$ReactHooksTemplate = require("./InsightsFilterForm.res.js");

var initialState = {
  loading: false,
  currentFilter: 0,
  filterPills: /* [] */0,
  filters: /* [] */0
};

function reducer(state, x) {
  if (typeof x !== "object") {
    return {
            loading: true,
            currentFilter: state.currentFilter,
            filterPills: state.filterPills,
            filters: state.filters
          };
  } else if (x.TAG === "FetchFiltersCompleted") {
    return {
            loading: false,
            currentFilter: state.currentFilter,
            filterPills: x._1,
            filters: x._0
          };
  } else {
    return {
            loading: state.loading,
            currentFilter: x._0,
            filterPills: x._1,
            filters: x._2
          };
  }
}

function InsightsFilters(props) {
  var correlation = props.correlation;
  var onApply = props.onApply;
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  var applyFilter = function (filters) {
    return Http$ReactHooksTemplate.fetchPostEncodedJSON("/api/v1/insights/set_filters?type=" + (
                correlation ? "correlation" : ""
              ), Json_encode.object_({
                    hd: [
                      "filters",
                      Json_encode.list(Filter$ReactHooksTemplate.encode, filters)
                    ],
                    tl: /* [] */0
                  }));
  };
  React.useEffect((function (param) {
          Curry._1(dispatch, "FetchFiltersInProgress");
          Js_promise.then_((function (xs) {
                  var filterPills = Belt_List.map(Belt_List.keep(xs, Filter$ReactHooksTemplate.isSelected), (function (x) {
                          return FilterPills$ReactHooksTemplate.make(Filter$ReactHooksTemplate.toString(x), x);
                        }));
                  return Promise.resolve(Curry._1(dispatch, {
                                  TAG: "FetchFiltersCompleted",
                                  _0: xs,
                                  _1: filterPills
                                }));
                }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/insights/filters?type=" + (
                    correlation ? "correlation" : ""
                  ), Filter$ReactHooksTemplate.fromJson));
        }), []);
  var handleSetFilter = function (filter) {
    var filterId = Filter$ReactHooksTemplate.id(filter);
    var filterString = Filter$ReactHooksTemplate.toString(filter);
    var filterPills = Belt_Option.isNone(Belt_List.head(Belt_List.keep(state.filterPills, (function (xs) {
                    return filterId === FilterPills$ReactHooksTemplate.id(xs);
                  })))) ? Belt_List.concat(state.filterPills, {
            hd: FilterPills$ReactHooksTemplate.make(filterString, filter),
            tl: /* [] */0
          }) : Belt_List.map(state.filterPills, (function (xs) {
              if (FilterPills$ReactHooksTemplate.id(xs) === filterId) {
                return FilterPills$ReactHooksTemplate.make(filterString, filter);
              } else {
                return xs;
              }
            }));
    console.log(filterPills);
    var filters = Belt_List.map(state.filters, (function (xs) {
            if (Filter$ReactHooksTemplate.id(xs) === filterId) {
              return filter;
            } else {
              return xs;
            }
          }));
    console.log(filters);
    Curry._1(dispatch, {
          TAG: "AddFilter",
          _0: filterId,
          _1: filterPills,
          _2: filters
        });
  };
  var handleResetFilter = function (filter) {
    var filterId = Filter$ReactHooksTemplate.id(filter);
    var filterPills = Belt_List.keep(state.filterPills, (function (x) {
            return filterId !== FilterPills$ReactHooksTemplate.id(x);
          }));
    var filters = Belt_List.map(state.filters, (function (x) {
            if (filterId === Filter$ReactHooksTemplate.id(x)) {
              return filter;
            } else {
              return x;
            }
          }));
    Js_promise.then_((function (param) {
            return Promise.resolve((Curry._1(dispatch, {
                              TAG: "AddFilter",
                              _0: filterId,
                              _1: filterPills,
                              _2: filters
                            }), Curry._1(onApply, undefined)));
          }), applyFilter(filters));
  };
  var displayDateFilter = function (xs) {
    var filter = Filter$ReactHooksTemplate.filterType(xs);
    var tmp;
    tmp = filter.TAG === "Date" ? JsxRuntime.jsx(DateFilterForm$ReactHooksTemplate.make, {
            filter: filter._0,
            onChange: (function (param) {
                var filter = Filter$ReactHooksTemplate.setFilterTypes(param, xs);
                var filterId = Filter$ReactHooksTemplate.id(filter);
                var filters = Belt_List.map(state.filters, (function (xs) {
                        if (Filter$ReactHooksTemplate.id(xs) === filterId) {
                          return filter;
                        } else {
                          return xs;
                        }
                      }));
                var filterPills = Belt_List.map(Belt_List.keep(filters, Filter$ReactHooksTemplate.isSelected), (function (x) {
                        return FilterPills$ReactHooksTemplate.make(Filter$ReactHooksTemplate.toString(x), x);
                      }));
                Js_promise.then_((function (param) {
                        return Promise.resolve((Curry._1(dispatch, {
                                          TAG: "FetchFiltersCompleted",
                                          _0: filters,
                                          _1: filterPills
                                        }), Curry._1(onApply, undefined)));
                      }), applyFilter(filters));
              }),
            displayFilterPills: false,
            disableDatePicker: correlation
          }) : JsxRuntime.jsx(JsxRuntime.Fragment, {});
    return JsxRuntime.jsx("div", {
                children: tmp
              });
  };
  var tmp;
  if (props.showDateFilter) {
    var match$1 = state.filters;
    tmp = match$1 ? JsxRuntime.jsx(JsxRuntime.Fragment, {
            children: Caml_option.some(displayDateFilter(match$1.hd))
          }) : JsxRuntime.jsx(JsxRuntime.Fragment, {});
  } else {
    tmp = props.showFilterPills ? $$Array.of_list(Belt_List.mapWithIndex(state.filterPills, (function (i, t) {
                  return JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(FilterPillsElement$ReactHooksTemplate.make, {
                                    t: t,
                                    handleResetFilter: handleResetFilter,
                                    height: "h-8"
                                  }),
                              className: "flex flex-wrap mr-1"
                            }, String(i));
                }))) : JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(InsightsFilterForm$ReactHooksTemplate.make, {
                        filters: state.filters,
                        filterPills: state.filterPills,
                        onClose: props.onClose,
                        onApply: onApply,
                        handleSetFilter: handleSetFilter,
                        handleResetFilter: handleResetFilter,
                        currentFilter: state.currentFilter,
                        correlation: correlation
                      }),
                  className: "bg-white w-1/2 fixed h-screen top-0 right-0 z-10 shadow"
                }),
            className: "w-screen z-10 disabled-wrapper absolute inset-0 flex justify-center items-center",
            style: {
              height: "calc(100vh + 5rem)"
            }
          });
  }
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
              children: Caml_option.some(tmp)
            });
}

var make = InsightsFilters;

exports.initialState = initialState;
exports.reducer = reducer;
exports.make = make;
/* react Not a pure module */
